<ng-container *ngIf="!maintenanceMode; else maintenance">
  <ng-container *ngIf="(brandingService.brandingInfo$ | async) && (brandingService.brandingInfo$ | async)?.id">
    <app-header id="top-of-app" class="app-header" *ngIf="!notSupportedPage"></app-header>
    <article class="content-container"
      [class.profile-background]="isUserUrl"
      [class.profile-background_freeway]="isUserUrl && customRgPage === 'freeway'">

      <!-- reskin P1: the two traced house SVGs (app-main-image-left/right, 126 KB
           of inline path data each) are replaced by the design's town skyline —
           one 2 KB masked asset, tinted with --gc-tint-200 so it follows a
           client's brand hue. This also fixes a real pre-existing bug: the old
           `.main-personalize__back`/`_left`/`_right` wrappers had NO CSS anywhere
           in the repo, so the two SVGs stacked unpositioned and the right one was
           largely clipped. Both gates are preserved verbatim: freeway keeps its
           own artwork, and `hide_houses_img_site_container` still suppresses the
           decoration entirely. `showBg` decides which routes get it — see
           shouldShowSkyline() in core/utils/skyline-routes.ts. That is the flow
           routes AND the static content pages, but never the portal. -->
      <ng-container *ngIf="customRgPage !== 'freeway'">
        <ng-container *unlessBrandingAttr="'hide_houses_img_site_container'">
          <div class="scene" *ngIf="showBg" aria-hidden="true">
            <div class="town"></div>
          </div>
        </ng-container>
      </ng-container>

      <div class="main-content" [ngClass]="mainContentClass">
        <router-outlet></router-outlet>
      </div>

    </article>
    <ng-container *ngIf="!notSupportedPage && !iframeMode">
      <!-- reskin unit D: the 438px legacy footer is replaced by the slim
           compliance footnote; freeway keeps its bespoke footer untouched -->
      <app-flow-footnote *ngIf="customRgPage !== 'freeway'"></app-flow-footnote>
      <app-freeway-layout-footer *ngIf="customRgPage === 'freeway'"></app-freeway-layout-footer>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #maintenance>
  <maintenance-page></maintenance-page>
</ng-template>
